import { Switch } from '@material-ui/core';
import React, { FC, memo, useCallback } from 'react';

interface Props {
  color: 'primary' | 'secondary' | 'default' | undefined;
  checked: boolean;
  onChange: (b: boolean) => void;
}

export const MuiSwitch: FC<Props> = memo(
  ({ color, checked, onChange }: Readonly<Props>) => {
    const onChangeHandler = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
      },
      [onChange]
    );

    return (
      <Switch color={color} checked={checked} onChange={onChangeHandler} />
    );
  }
);

MuiSwitch.displayName = 'MuiSwitch';
